import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class AppStorageService {
    private _fallbackSessionStorage: Record<string, string> = {};
    private _memoryStorage: Record<string, string> = {};

    getFromSessionStorage(key: string): string | null {
        try {
            return sessionStorage.getItem(key);
        } catch (err) {
            return this._fallbackSessionStorage[key] ?? null;
        }
    }

    setToSessionStorage(key: string, value: string): void {
        try {
            sessionStorage.setItem(key, value);
        } catch (err) {
            this._fallbackSessionStorage[key] = value;
        }
    }

    removeFromSessionStorage(key: string): void {
        try {
            sessionStorage.removeItem(key);
        } catch (err) {
            delete this._fallbackSessionStorage[key];
        }
    }

    /** Reads a value that lasts for the current application runtime only. */
    getFromMemoryStorage(key: string): string | null {
        return this._memoryStorage[key] ?? null;
    }

    /** Stores a value that survives in-app navigation but not a full page reload. */
    setToMemoryStorage(key: string, value: string): void {
        this._memoryStorage[key] = value;
    }

    /** Removes a value from the current application runtime storage. */
    removeFromMemoryStorage(key: string): void {
        delete this._memoryStorage[key];
    }
}
